import { useState } from "react";
import MobileSidebar from "./MobileSidebar";
import MobileBasicDetails from "./MobileBasicInfoStep";
import MobileAddressDetails from "./MobileAddressStep";
import MobileKycDetails from "./MobileKycStep";
import { MobileFormProvider } from "./MobileFormContext";

const MobileOnboarding = () => {
  const [step, setStep] = useState(1);

  return (
    <div className="w-full h-full bg-gray-50 flex flex-col rounded-xl items-center justify-start">
      <div className="w-full max-w-md bg-white-1 rounded-xl shadow-md overflow-hidden">
        <MobileSidebar step={step} />
        <MobileFormProvider>
          <div className="p-4">
            {step === 1 && <MobileBasicDetails onNext={() => setStep(2)} />}
            {step === 2 && (
              <MobileAddressDetails
                onNext={() => setStep(3)}
                onBack={() => setStep(1)}
              />
            )}
            {step === 3 && <MobileKycDetails onBack={() => setStep(2)} />}
          </div>
        </MobileFormProvider>
      </div>
    </div>
  );
};

export default MobileOnboarding;
